<script setup lang="ts">
import ButtonToggle from '@/components/shared/ButtonToggle.vue'
import Icon from '@/components/shared/Icon.vue'
import { generateIconColor } from '@/lib'

defineProps<{ title: string, icon?: string }>()
defineEmits<{ close: [] }>()
</script>

<template>
  <div class="flex items-start justify-between gap-x-4">
    <div class="flex min-w-0 gap-x-2.5 items-start">
      <Icon
        v-if="icon"
        :variant="icon"
        class="mt-0.5 h-5 w-5 shrink-0"
        v-bind="generateIconColor('primary')"
      />
      <h3 class="min-w-0 break-words text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">
        {{ title }}
      </h3>
    </div>

    <ButtonToggle class="shrink-0" @click="$emit('close')">
      <Icon variant="x" class="pointer-events-none h-[21px] w-[21px] text-primary-500 dark:text-gray-300 hover:dark:text-gray-100 transition-colors" :stroke-width="1.7" />
    </ButtonToggle>
  </div>
</template>
